// eslint-disable-next-line no-unused-vars
import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { ComboBox } from '@carbon/react';
import { Controller } from 'react-hook-form';
import { object } from 'prop-types';

const StyledComboBox = styled.div`
  .cds--list-box__wrapper {
    position: relative;

    .cds--form-requirement {
      position: absolute;
      top: 100%;;
    }
  }

  .cds--combo-box {
    margin-bottom: 20px;
    border: 1px solid ${ props => props.theme.products.colors.border };
    border-radius: 5px;
    background-color: transparent;

    &[data-invalid] .cds--text-input:not(:focus) {
      outline: 1px solid #da1e28;
      outline-offset: 0px;
    }
  }

  .cds--label {
    &:before {
      background: transparent;
      transform: none;
      transition: none;
      animation: none;
      will-change: unset;
    }

    &:after {
      content: '*';
      display: inline-block;
      margin-left: 5px;
      color: ${ props => props.theme.colors.default };
    }

    font-size: 0.875rem;
    color: ${ props => props.theme.colors.darkGray };
  }

  .cds--list-box__selection {
    display: ${ props => (props.hideClearButton ? 'none' : 'flex') };
  }

  .cds--list-box__field {
    padding: 0;
  }

  .cds--list-box__menu-item {
    background-color: #fff;

    &.cds--list-box__menu-item--active {
      background-color: #CACACA;
    }

    &:hover {
      background-color: #E5E5E5;
    }
  }

  input {
    border: 0;
  }
`;

const NWComboBox = forwardRef(({ className, control, name, rules, id, items, hideClearButton = true, ...rest }, ref) => {
  const theme = useTheme();
  const comboBoxProps = { ...rest, name, id, ref, items };

  return (
    <StyledComboBox
      theme={ theme }
      hideClearButton={ hideClearButton }
      className={ className }
      hide
    >
      { control ? (
        <Controller
          name={ name }
          control={ control }
          rules={ rules }
          render={({ field: { onBlur, onFocus, ref: cRef } }) => (
            <ComboBox
              { ...comboBoxProps }
              className="NW-ComboBoxWrapper"
              onBlur={ onBlur }
              onFocus={ onFocus }
              ref={ cRef }
              data-test={ id }
            />
          )}
        />
      ) : (
        <ComboBox
          data-test={ id }
          { ...comboBoxProps }
          className="NW-ComboBoxWrapper"
          ref={ ref }
        />
      ) }
    </StyledComboBox>
  );
});

NWComboBox.propTypes = {
  ...ComboBox.propTypes,
  control: object,
  rules: object,
};

export { NWComboBox };
